import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IYonetimKullaniciEkle_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IYonetimKullaniciEkle_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  Get_Helpers_LoginUserInfo: any[];
  Get_Helpers_LoginUserInfo_dummy: any[];
  Get_Yonetim_FirmaListe: any[];
  Get_Yonetim_FirmaListe_dummy: any[];
  Get_Helpers_RoleList: any[];
  Get_Helpers_RoleList_dummy: any[];
  Get_Yonetim_KullaniciById: any[];
  Get_Yonetim_KullaniciById_dummy: any[];
  GoBack: any;
  GoBack_dummy: any;
  CreateUserWithPassword: string;
  CreateUserWithPassword_dummy: string;
  Get_Helpers_UserInfoByUserName: any[];
  Get_Helpers_UserInfoByUserName_dummy: any[];
  Add_Yonetim_KullaniciFirma: number;
  Add_Yonetim_KullaniciFirma_dummy: number;
  RemoveUserFromRole: boolean;
  RemoveUserFromRole_dummy: boolean;
  AddUserToRole: boolean;
  AddUserToRole_dummy: boolean;
  GetYeniKullaniciMailBody: string;
  GetYeniKullaniciMailBody_dummy: string;
  SendMail: boolean;
  SendMail_dummy: boolean;
  isComp742500Visible: "visible" | "hidden";
}

export class YonetimKullaniciEkle_ScreenBase extends React.PureComponent<
  IYonetimKullaniciEkle_ScreenProps,
  any
> {
  yonetimkullaniciekle_810791_value_kuikaSelectBoxRef: React.RefObject<any>;
  ml = [
    {
      Id: "585b6303-ac4a-473f-8893-c915ede3bf84",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "9e061df9-e2cd-435d-b514-71055786aed8",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 891214,
          PropertyName: "value",
          Value: "KULLANICI EKLEME - DÜZENLEME",
        },
        { Id: 48474, PropertyName: "value", Value: "Kullanıcı Adı" },
        { Id: 198377, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 767051, PropertyName: "value", Value: "Parola" },
        { Id: 607530, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 684043, PropertyName: "value", Value: "Ad" },
        { Id: 249909, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 172445, PropertyName: "value", Value: "Soyad" },
        { Id: 742449, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 249608, PropertyName: "value", Value: "Firma" },
        { Id: 810791, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 974814, PropertyName: "label", Value: "Vazgeç" },
        { Id: 865072, PropertyName: "label", Value: "Kaydet" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.yonetimkullaniciekle_198377_value_kuikaTextInputRef =
      React.createRef();
    this.yonetimkullaniciekle_607530_value_kuikaTextInputRef =
      React.createRef();
    this.yonetimkullaniciekle_249909_value_kuikaTextInputRef =
      React.createRef();
    this.yonetimkullaniciekle_742449_value_kuikaTextInputRef =
      React.createRef();
    this.yonetimkullaniciekle_810791_value_kuikaSelectBoxRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      Get_Helpers_LoginUserInfo: [],
      Get_Yonetim_FirmaListe: [],
      Get_Helpers_RoleList: [],
      Get_Yonetim_KullaniciById: [],
      GoBack: "",
      CreateUserWithPassword: "",
      Get_Helpers_UserInfoByUserName: [],
      Add_Yonetim_KullaniciFirma: 0,
      RemoveUserFromRole: false,
      AddUserToRole: false,
      GetYeniKullaniciMailBody: "",
      SendMail: false,
      isComp742500Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("yonetimkullaniciekle", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.YonetimKullaniciEklePageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("yonetimkullaniciekle", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("yonetimkullaniciekle", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.YonetimKullaniciEklePageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      yonetimkullaniciekle_198377_value:
        this.state.Get_Yonetim_KullaniciById?.at?.(0)?.userName ?? undefined,
      yonetimkullaniciekle_249909_value:
        this.state.Get_Yonetim_KullaniciById?.at?.(0)?.firstName ?? undefined,
      yonetimkullaniciekle_742449_value:
        this.state.Get_Yonetim_KullaniciById?.at?.(0)?.lastName ?? undefined,
      yonetimkullaniciekle_810791_value:
        this.state.Get_Yonetim_KullaniciById?.at?.(0)?.firmaId ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  YonetimKullaniciEklePageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      UserId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_LoginUserInfo !== undefined
            ? stateVars.Get_Helpers_LoginUserInfo?.length > 0
              ? stateVars.Get_Helpers_LoginUserInfo[0].id
              : null
            : this.state.Get_Helpers_LoginUserInfo?.length > 0
            ? this.state.Get_Helpers_LoginUserInfo[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YonetimKullaniciEkle/YonetimKullaniciEklePageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Helpers_LoginUserInfo =
      result?.data.get_Helpers_LoginUserInfo;
    stateVars.Get_Yonetim_FirmaListe = result?.data.get_Yonetim_FirmaListe;

    formVars.yonetimkullaniciekle_810791_options =
      stateVars.Get_Yonetim_FirmaListe;
    stateVars.Get_Helpers_RoleList = result?.data.get_Helpers_RoleList;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YonetimKullaniciEklePageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YonetimKullaniciEklePageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.KullaniciId ??
          this.props.screenInputs.kullaniciid,
        "Guid"
      ),
    };

    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.KullaniciId ??
          this.props.screenInputs.kullaniciid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "YonetimKullaniciEkle/YonetimKullaniciEklePageInit1_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.Get_Yonetim_KullaniciById =
        result?.data.get_Yonetim_KullaniciById;
      formVars.yonetimkullaniciekle_198377_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Yonetim_KullaniciById !== undefined
            ? stateVars.Get_Yonetim_KullaniciById?.length > 0
              ? stateVars.Get_Yonetim_KullaniciById[0].userName
              : null
            : this.state.Get_Yonetim_KullaniciById?.length > 0
            ? this.state.Get_Yonetim_KullaniciById[0].userName
            : null
        );
      formVars.yonetimkullaniciekle_249909_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Yonetim_KullaniciById !== undefined
            ? stateVars.Get_Yonetim_KullaniciById?.length > 0
              ? stateVars.Get_Yonetim_KullaniciById[0].firstName
              : null
            : this.state.Get_Yonetim_KullaniciById?.length > 0
            ? this.state.Get_Yonetim_KullaniciById[0].firstName
            : null
        );
      formVars.yonetimkullaniciekle_742449_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Yonetim_KullaniciById !== undefined
            ? stateVars.Get_Yonetim_KullaniciById?.length > 0
              ? stateVars.Get_Yonetim_KullaniciById[0].lastName
              : null
            : this.state.Get_Yonetim_KullaniciById?.length > 0
            ? this.state.Get_Yonetim_KullaniciById[0].lastName
            : null
        );
      formVars.yonetimkullaniciekle_810791_value =
        stateVars.Get_Yonetim_KullaniciById !== undefined
          ? stateVars.Get_Yonetim_KullaniciById?.length > 0
            ? stateVars.Get_Yonetim_KullaniciById[0].firmaId
            : null
          : this.state.Get_Yonetim_KullaniciById?.length > 0
          ? this.state.Get_Yonetim_KullaniciById[0].firmaId
          : null;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimKullaniciEklePageInit2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimKullaniciEklePageInit2_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YonetimKullaniciEklePageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.KullaniciId ??
          this.props.screenInputs.kullaniciid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.yonetimkullaniciekle_198377_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Yonetim_KullaniciById !== undefined
            ? stateVars.Get_Yonetim_KullaniciById?.length > 0
              ? stateVars.Get_Yonetim_KullaniciById[0].userName
              : null
            : this.state.Get_Yonetim_KullaniciById?.length > 0
            ? this.state.Get_Yonetim_KullaniciById[0].userName
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimKullaniciEklePageInit3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimKullaniciEklePageInit3_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YonetimKullaniciEklePageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp742500Visible =
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.KullaniciId ??
          this.props.screenInputs.kullaniciid,
        "00000000-0000-0000-0000-000000000000"
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YonetimKullaniciEklePageInit4_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YonetimKullaniciEklePageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.KullaniciId ??
          this.props.screenInputs.kullaniciid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.yonetimkullaniciekle_249909_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Yonetim_KullaniciById !== undefined
            ? stateVars.Get_Yonetim_KullaniciById?.length > 0
              ? stateVars.Get_Yonetim_KullaniciById[0].firstName
              : null
            : this.state.Get_Yonetim_KullaniciById?.length > 0
            ? this.state.Get_Yonetim_KullaniciById[0].firstName
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimKullaniciEklePageInit5_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimKullaniciEklePageInit5_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YonetimKullaniciEklePageInit5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.KullaniciId ??
          this.props.screenInputs.kullaniciid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.yonetimkullaniciekle_742449_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Yonetim_KullaniciById !== undefined
            ? stateVars.Get_Yonetim_KullaniciById?.length > 0
              ? stateVars.Get_Yonetim_KullaniciById[0].lastName
              : null
            : this.state.Get_Yonetim_KullaniciById?.length > 0
            ? this.state.Get_Yonetim_KullaniciById[0].lastName
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimKullaniciEklePageInit6_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimKullaniciEklePageInit6_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YonetimKullaniciEklePageInit6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.KullaniciId ??
          this.props.screenInputs.kullaniciid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.yonetimkullaniciekle_810791_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Yonetim_KullaniciById !== undefined
            ? stateVars.Get_Yonetim_KullaniciById?.length > 0
              ? stateVars.Get_Yonetim_KullaniciById[0].firmaId
              : null
            : this.state.Get_Yonetim_KullaniciById?.length > 0
            ? this.state.Get_Yonetim_KullaniciById[0].firmaId
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimKullaniciEklePageInit7_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimKullaniciEklePageInit7_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YonetimKullaniciEklePageInit7_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_810791 =
      stateVars.Get_Yonetim_FirmaListe ?? this.state.Get_Yonetim_FirmaListe;
    stateVars.dataSource_810791 =
      stateVars.Get_Yonetim_FirmaListe ?? this.state.Get_Yonetim_FirmaListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  YonetimKullaniciEkleComponent_974814_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "43fc490a_712c_ab21_16b0_3731dcc99abb_confirmation",
        this.defaultML,
        "Kayıt edilmeyen veriler iptal edilecek"
      ),
      "poppins",
      "",
      "",
      "#246dff"
    );

    if (stateVars.Confirm) {
      KuikaAppManager.showSpinner(this);

      stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  YonetimKullaniciEkleComponent_865072_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.CreateUserWithPassword =
      await ReactSystemFunctions.createUserWithPassword(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yonetimkullaniciekle_198377_value",
            "value",
            "",
            "",
            ""
          )
        ),
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yonetimkullaniciekle_607530_value",
            "value",
            "",
            "",
            ""
          )
        ),
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yonetimkullaniciekle_249909_value",
            "value",
            "",
            "",
            ""
          )
        ),
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yonetimkullaniciekle_742449_value",
            "value",
            "",
            "",
            ""
          )
        ),
        false,
        ReactSystemFunctions.convertToTypeByName("", "string"),
        ReactSystemFunctions.convertToTypeByName("", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YonetimKullaniciEkleComponent_865072_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YonetimKullaniciEkleComponent_865072_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yonetimkullaniciekle_198377_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YonetimKullaniciEkle/YonetimKullaniciEkleComponent_865072_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Helpers_UserInfoByUserName =
      result?.data.get_Helpers_UserInfoByUserName;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YonetimKullaniciEkleComponent_865072_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YonetimKullaniciEkleComponent_865072_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KullaniciId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
      FirmaId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yonetimkullaniciekle_810791_value",
            "value",
            "Get_Yonetim_FirmaListe",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      BagliFirmaId_0: ReactSystemFunctions.convertToTypeByName(
        "00000000-0000-0000-0000-000000000000",
        "Guid"
      ),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.KullaniciId ??
          this.props.screenInputs.kullaniciid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "YonetimKullaniciEkle/YonetimKullaniciEkleComponent_865072_onClick2_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.Add_Yonetim_KullaniciFirma =
        result?.data.add_Yonetim_KullaniciFirma;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YonetimKullaniciEkleComponent_865072_onClick3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YonetimKullaniciEkleComponent_865072_onClick3_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YonetimKullaniciEkleComponent_865072_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    stateVars.RemoveUserFromRole =
      await ReactSystemFunctions.removeUserFromRole(
        ReactSystemFunctions.convertToTypeByName("_SystemAdmin", "string"),
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yonetimkullaniciekle_198377_value",
            "value",
            "",
            "",
            ""
          )
        )
      );
    stateVars.AddUserToRole = await ReactSystemFunctions.addUserToRole(
      ReactSystemFunctions.convertToTypeByName("TmsUser", "string"),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "yonetimkullaniciekle_198377_value",
          "value",
          "",
          "",
          ""
        )
      )
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YonetimKullaniciEkleComponent_865072_onClick4_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YonetimKullaniciEkleComponent_865072_onClick4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      SirketAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yonetimkullaniciekle_810791_value",
            "value",
            "Get_Yonetim_FirmaListe",
            "id",
            "firmaAdi"
          )
        ),
        "string"
      ),
      KullaniciAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yonetimkullaniciekle_198377_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      templateId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      receivers_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "satis@arunayazilim.com",
          "string"
        ),
        "string"
      ),
      subject_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "Aruna TMS - Yeni Kullanici Olusturuldu",
          "string"
        ),
        "string"
      ),
      sender_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      cc_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      bcc_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      language_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      body_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.GetYeniKullaniciMailBody),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YonetimKullaniciEkle/YonetimKullaniciEkleComponent_865072_onClick4_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetYeniKullaniciMailBody = result?.data.getYeniKullaniciMailBody;
    stateVars.SendMail = result?.data.sendMail;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YonetimKullaniciEkleComponent_865072_onClick5_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YonetimKullaniciEkleComponent_865072_onClick5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.YonetimKullaniciEklePageInit();
    }
  }
}
